var protocolRegexp = /^((http(s)?\:)?\/\/)/;
export default (function (url) {
  return url.replace(protocolRegexp, '');
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@livechat/url-utils/es/removeProtocol.js
// module id = 534
// module chunks = 0